<template lang="pug">
    #app
        MenuSuperiorTrilhaPssc(
            :modoExibicao='modoExibicao',
            :idTerritorio='territorio',
            :idUsuarioLogado='usuarioLogado'
        )

        section.conteudo-trilha-vazia(v-if='!dadosTrilha')
            div.trilha__card.trilha__card__trilha-vazia
                div.trilha-vazia__content
                    img(src="@/assets/lyra-icons/pssc/gestao-lotes-lista-vazia.svg", height="121px", width="200px")
                    div.trilha-vazia__content__titulo
                        | {{ $t('mensagens.pssc.telaVisualizarTrilha.naoHaTrilhaDisponivel') }}
                    div.trilha-vazia__content__subtitulo
                        | {{ $t('mensagens.pssc.telaVisualizarTrilha.verifiqueEndereco') }}

        section.conteudo-trilha-pssc(v-else)
            #visao-trilha-pssc(v-loading="loadingDadosTrilha")
                div.trilha__card.trilha-regularizacao
                    .dados-trilha
                        span.trilha-regularizacao__titulo {{ $t('mensagens.pssc.telaVisualizarTrilha.trilhaRegularizacao') }}
                        .dados-car-analisado
                            div.field-label {{ $t('mensagens.pssc.telaVisualizarTrilha.carAnalisado') }}
                            div.field-value-car {{ this.dadosTrilha.diagnosticoCar.car }}
                    .dados-solicitacao
                        .dados-solicitante
                            div.solicitante-label {{ $t('mensagens.pssc.telaVisualizarTrilha.solicitante') }}
                            div.solicitante-value {{ this.dadosTrilha.solicitante }}
                        .data-solicitacao
                            div.solicitante-label {{ $t('mensagens.pssc.telaVisualizarTrilha.dataRelatorio') }}
                            div.solicitante-value {{ this.dataHoraConsulta[0] }}
                                span.hora-solicitacao {{ ' - ' + this.dataHoraConsulta[1] }}
                div.trilha__card
                    span.titulo-secao {{ $t('mensagens.pssc.telaVisualizarTrilha.dadosGeraisImovel') }}
                    div.divider
                    div.dados-gerais__grid
                        div
                            div.field-label {{ $t('mensagens.pssc.telaVisualizarTrilha.situacaoCadastro') }}
                            div.field-value {{ this.validaSituacao(this.dadosTrilha.diagnosticoCar.situacaoCadastro) }}
                        div
                            div.field-label {{ $t('mensagens.pssc.telaVisualizarTrilha.condicao') }}
                            div.field-value {{ this.dadosTrilha.diagnosticoCar.condicao }}
                        div
                            div.field-label {{ $t('mensagens.pssc.telaVisualizarTrilha.localidade') }}
                            div.field-value {{ this.dadosTrilha.diagnosticoCar.localidade }}
                        div
                            div.field-label {{ $t('mensagens.pssc.telaVisualizarTrilha.situacaoReservaLegal') }}
                            div.field-value {{ this.dadosTrilha.diagnosticoCar.situacaoReservaLegal }}
                        div
                            div.field-label {{ $t('mensagens.pssc.telaVisualizarTrilha.bioma') }}
                            div.field-value {{ this.dadosTrilha.diagnosticoCar.bioma }}
                        div
                            div.field-label {{ $t('mensagens.pssc.telaVisualizarTrilha.aderiuPra') }}
                            div.field-value {{ this.dadosTrilha.diagnosticoCar.aderiuPRA }}
                        div
                            div.field-label {{ $t('mensagens.pssc.telaVisualizarTrilha.moduloFiscal') }}
                            div.field-value {{ this.dadosTrilha.diagnosticoCar.moduloFiscal }}
                        div
                            div.field-label {{ $t('mensagens.pssc.telaVisualizarTrilha.areaImovel') }}
                            div.field-value {{ this.dadosTrilha.areaImovel + ' ha' }}

                div.inconformidades-encontradas
                    div.trilha__card
                        span.titulo-secao {{ $t('mensagens.pssc.telaVisualizarTrilha.totalInconformidadesEncontradas') }}
                        div.divider
                        div.indicador-inconformidades(:class='getClassInconformidade(dadosTrilha.totalRestricoesDiagnosticoCar)')
                            div
                                el-tag(effect="dark", type="primary", size="small",
                                    style="border: none; padding-top: 2px")
                                    i(:class='getIconInconformidade(dadosTrilha.totalRestricoesDiagnosticoCar)')
                            div.indicador-descricao
                                .inconformidade-titulo {{ $t('mensagens.pssc.telaVisualizarTrilha.diagnosticoSocioambiental') }}
                                .inconformidade-label {{ $t('mensagens.pssc.telaVisualizarTrilha.inconformidades') }}
                                    span.inconformidade-value {{ this.formatNumberTwoDigits(this.dadosTrilha.totalRestricoesDiagnosticoCar) }}
                        div.indicador-inconformidades(:class='getClassInconformidade(dadosTrilha.totalInconformidadesCfb)')
                            div
                                el-tag(effect="dark", type="primary", size="small",
                                    style="border: none; padding-top: 2px")
                                    i(:class='getIconInconformidade(dadosTrilha.totalInconformidadesCfb)')
                            div.indicador-descricao
                                .inconformidade-titulo {{ $t('mensagens.pssc.telaVisualizarTrilha.adequacaoAoCfb') }}
                                .inconformidade-label {{ $t('mensagens.pssc.telaVisualizarTrilha.inconformidades') }}
                                    span.inconformidade-value {{ this.formatNumberTwoDigits(this.dadosTrilha.totalInconformidadesCfb) }}

                    MapaPssc.mapa-trilha(
                        v-if='dadosTrilha',
                        :mapLayersConfigs='layersMaps',
                        :mapConfig='mapConfig',
                        :height='"100%"',
                        :idMapa='"mapaPssc"',
                        ref='mapa',
                        :atualizarMapa='true',
                        :cluster='false'
                    )

                div.trilha__card
                    span.titulo-secao {{ $t('mensagens.pssc.telaVisualizarTrilha.orientacoes') }}
                    div.divider
                    div
                        div.orientacoes-container(v-html="dadosTrilha.trilhaRegularizacao.resultado")

                div.trilha__card
                    div(style='word-break: keep-all !important; text-align: justify')
                        span.texto-rodape-destaque {{ $t('mensagens.pssc.telaVisualizarTrilha.rodape.vegaMonitoramento') }}
                        span.texto-rodape {{ $t('mensagens.pssc.telaVisualizarTrilha.rodape.primeiroParagrafo') }}
                    div(style='margin-top: 16px').texto-rodape {{ $t('mensagens.pssc.telaVisualizarTrilha.rodape.segundoParagrafo') }}

        Loading
</template>

<script>
import MenuSuperiorTrilhaPssc from '@/components/pssc/trilha/MenuSuperiorTrilhaPssc.vue';
import MapaPssc from '@/components/pssc/MapaPssc.vue';
import {getEstiloGeometria} from '@/utils/mapa/mapa.estilos';
import formatters from '@/utils/formatters';
import PSSCPublicService from '@/services/PSSCPublicService';
import {OrientacoesTrilhaPssc} from '@/constants/OrientacoesTrilhaPsscEnum';
import Loading from '@/components/Loading';

export default {
    name: 'TrilhaPssc',
    components: {
        MapaPssc,
        MenuSuperiorTrilhaPssc,
        Loading
    },
    data() {
        return {
            territorio: null,
            representante: null,
            modoExibicao: '',
            usuarioLogado: null,
            layersMaps: [],
            mapConfig: {
                controls: {
                    popupControl: false,
                    zoomControl: true,
                    fullscreen: true
                },
                inspecionar: false,
                diagnostico: false
            },
            dadosTrilha: null,
            dataHoraConsulta: null,
            loadingDadosTrilha: false
        };
    },
    async mounted() {
        const url = window.location.href;
        let urlParts = url.split('/pssc/trilha/')[1].split('/');
        if (url.includes('visao-trilha') && sessionStorage.getItem('dadosUsuario')) {
            this.territorio = urlParts[0];
            this.usuarioLogado = urlParts[2];
            if (JSON.parse(sessionStorage.getItem('dadosUsuario')).idKeyCloack === this.usuarioLogado) {
                this.modoExibicao = 'visao-trilha';
                this.fetchDadosTrilhaUsuarioLogado();
            }
        } else {
            this.modoExibicao = 'visao-produtor';
            this.territorio = urlParts[0];
            this.representante = urlParts[1];
            this.fetchDadosTrilha();
        }
    },
    watch: {
        'dadosTrilha'(val) {
            if (val && this.territorio && this.representante && this.modoExibicao === 'visao-produtor') {
                this.atualizarStatusTrilha();
            }
        }
    },
    methods: {
        async fetchDadosTrilha() {
            this.loadingDadosTrilha = true;
            try {
                await PSSCPublicService.buscarDadosTrilha({
                    idTerritorio: this.territorio,
                    idRepresentante: this.representante
                }).then(({data}) => {
                    this.dadosTrilha = data;
                    let resultado = data.trilhaRegularizacao.resultado.replace(/\\n/g, '<br>');
                    resultado = resultado.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
                    resultado = resultado.replace(/^"|"$/g, '');

                    this.dadosTrilha.trilhaRegularizacao.resultado = resultado;
                    this.dataHoraConsulta = formatters.localDateTimeToString(data.trilhaRegularizacao.dataConsulta, this.$i18n.locale).split(', ');
                }).finally(() => {
                    this.mostrarTerritorioNoMapa(this.dadosTrilha.diagnosticoCar.geometria);
                    this.loadingDadosTrilha = false;
                });
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.pssc.telaVisualizarTrilha.erroBuscarDadosTrilha')
                });
                this.loadingDadosTrilha = false;
            }
        },
        async fetchDadosTrilhaUsuarioLogado() {
            this.loadingDadosTrilha = true;
            try {
                await PSSCPublicService.buscarDadosTrilhaUsuarioLogado({
                    idTerritorio: this.territorio,
                    idUsuarioLogado: this.usuarioLogado
                }).then(({data}) => {
                    this.dadosTrilha = data;
                    let resultado = data.trilhaRegularizacao.resultado.replace(/\\n/g, '<br>');
                    resultado = resultado.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
                    resultado = resultado.replace(/^"|"$/g, '');

                    this.dadosTrilha.trilhaRegularizacao.resultado = resultado;
                    this.dataHoraConsulta = formatters.localDateTimeToString(data.trilhaRegularizacao.dataConsulta, this.$i18n.locale).split(', ');
                }).finally(() => {
                    this.mostrarTerritorioNoMapa(this.dadosTrilha.diagnosticoCar.geometria);
                    this.loadingDadosTrilha = false;
                });
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.pssc.telaVisualizarTrilha.erroBuscarDadosTrilha')
                });
                this.loadingDadosTrilha = false;
            }
        },
        async atualizarStatusTrilha() {
            await PSSCPublicService.atualizarStatusTrilha({
                idTerritorio: this.territorio,
                idRepresentante: this.representante
            });
        },
        validaSituacao(situacao) {
            if (situacao) {
                switch (situacao) {
                    case 'AT':
                        return this.$t('mensagens.diagnosticoSocioambiental.situacoes.ativo');
                    case 'PE':
                        return this.$t('mensagens.diagnosticoSocioambiental.situacoes.pendente');
                    case 'SU':
                        return this.$t('mensagens.diagnosticoSocioambiental.situacoes.suspenso');
                    case 'CA':
                        return this.$t('mensagens.diagnosticoSocioambiental.situacoes.cancelado');
                    case 'RE':
                        return this.$t('mensagens.diagnosticoSocioambiental.situacoes.retificado');
                }
            } else {
                return '--';
            }
        },
        getNomeOrientacao(orientacao) {
            return OrientacoesTrilhaPssc[orientacao];
        },
        mostrarTerritorioNoMapa(geometria, clearLayers) {
            if (clearLayers == null || clearLayers) {
                this.layersMaps = [];
            }
            const layersToAdd = [];

            layersToAdd.push({
                style: getEstiloGeometria('area'),
                name: 'Car',
                geoJson: geometria
            });
            this.$bus.$emit('mapa:show-buffer', true);

            layersToAdd.forEach(l => {
                this.layersMaps.push(l);
            });
        },
        getClassInconformidade(tipo) {
            if (parseInt(tipo) === 0) return 'inconformidades-encontradas__success';
            return 'inconformidades-encontradas__warning';
        },
        getIconInconformidade(tipo) {
            if (parseInt(tipo) === 0) return 'mdi mdi-check-circle-outline';
            return 'mdi mdi-alert-circle-outline warning';
        },
        formatNumberTwoDigits(input) {
            return (input && input !== '') ? formatters.formatIntegerTwoDigits(input) : '--';
        }
    }
};
</script>

<style lang="scss">
#app {
    overflow: hidden;

    @media (max-width: 768px) {
        height: calc(100vh - 57px);
    }
}

.conteudo-trilha-pssc {
    background-color: #e1e1e1;
    width: 100vw;
    margin-top: 65px;
    padding: 24px;
    overflow-y: auto;
    height: calc(100vh - 65px);

    /* width */
    ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        border-radius: 10px;
        background: var(--white);
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: var(--primary);
        border-radius: 10px;
        border: 1px solid var(--white);
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #b5b5b5;
    }

    @media (max-width: 768px) {
        height: calc(100% - 70px);
        padding: 16px 8px 16px 8px !important;

        #visao-trilha-pssc {
            height: fit-content;
        }
    }
}

.conteudo-trilha-vazia {
    background-color: #e1e1e1;
    width: 100vw;
    margin-top: 65px;
    padding: 24px;
    overflow-y: auto;
    height: calc(100vh - 65px);

    .trilha__card__trilha-vazia {
        height: calc(100vh - 113px);
        padding: 12% 0;
    }

    .trilha-vazia__content {
        display: grid;
        justify-items: center;
        width: 100%;
        text-align: center;

        .trilha-vazia__content__titulo {
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 15px;
        }

        .trilha-vazia__content__subtitulo {
            font-size: 14px;
            margin-bottom: 15px;
        }
    }

    @media (max-width: 768px) {
        padding: 16px 8px 16px 8px !important;

        .trilha__card__trilha-vazia {
            height: calc(100vh - 100px);
            padding: 50% 24px;
        }
    }
}

.trilha__card {
    padding: 16px;
    background: white;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
}

#visao-trilha-pssc {
    height: fit-content;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .trilha-regularizacao {
        display: grid;
        grid-template-columns: 70% 30%;
    }

    .field-label {
        font-size: 14px;
        font-weight: 400;
    }

    .field-value-car {
        font-size: 16px;
        font-weight: 500;
        color: var(--primary);
    }

    .field-value {
        font-size: 14px;
        font-weight: 500;
        color: var(--primary);
    }

    .titulo-secao {
        font-size: 16px;
        font-weight: 500;
        color: var(--primary);
    }

    .texto-rodape-destaque {
        font-size: 10px;
        font-weight: 600;
        color: #00413C;
    }

    .texto-rodape {
        font-size: 10px;
        font-weight: 400;
        color: #00413C;
    }

    .orientacoes-header {
        height: 48px;
        width: 100%;
        margin-top: 20px;
        background-color: #FDF7E8;
        border: 1px solid #F9E5B9;
        border-radius: 4px 4px 0 0;
        display: flex;
        gap: 8px;
        padding: 12px 18px;

        i {
            color: #EDAB1D;
            font-size: 13px;
            margin-top: 1px;
        }

        .orientacoes-header-titulo {
            color: #3B3B3B;
            font-size: 14px;
            font-weight: 600;
        }
    }

    .orientacoes-container {
        height: fit-content;
        width: 100%;
        border: 1px solid #CCCCCC;
        border-radius: 0 0 4px 4px;
        padding: 16px;
    }

    .divider {
        border: 1px solid var(--primary);
    }

    .dados-car-analisado {
        margin-top: 13px;
    }

    .dados-solicitacao {
        display: flex;
        gap: 33px;
        justify-content: right;

        .solicitante-label {
            font-size: 10px;
            font-weight: 400;
        }

        .solicitante-value {
            font-size: 10px;
            font-weight: 500;
            color: var(--primary);
        }

        .hora-solicitacao {
            font-size: 10px;
            font-weight: 500;
            color: #7C7C7C;
        }

        .data-solicitacao {
            width: 100px;
        }
    }

    .dados-gerais__grid {
        display: grid;
        grid-template-columns: 25% 25% 25% 25%;
        margin-top: 16px;
        row-gap: 16px;
    }

    .inconformidades-encontradas__success {
        .el-tag {
            background-color: #43A349;
        }

        .inconformidade-value {
            color: #43A349;
        }
    }

    .inconformidades-encontradas__warning {
        .el-tag {
            background-color: #dc362e;
        }

        .inconformidade-value {
            color: #dc362e;
        }
    }

    .inconformidades-encontradas {
        display: grid;
        grid-template-columns: 30% 70%;
        height: fit-content !important;
        gap: 16px;

        .indicador-inconformidades {
            display: flex;
            gap: 16px;
            margin-top: 18px;

            .el-tag {
                width: 29px;
                height: 29px;
                padding: 3.5px 7.5px !important;

                i {
                    margin-left: -1px;
                    margin-top: 50px;
                    font-size: 16px;
                    color: var(--white);
                    height: fit-content !important;
                }
            }

            .el-tag-inconformidade__success {
                background-color: #43A349;
            }

            .el-tag-inconformidade__warning {
                background-color: #EDAB1D;
            }

            .indicador-descricao {
                margin-top: -3px;
            }

            .inconformidade-titulo {
                font-size: 14px;
                font-weight: 500;
            }

            .inconformidade-label {
                font-size: 12px;
                font-weight: 400;
            }

            .inconformidade-value {
                font-size: 12px;
                font-weight: 700;
                margin-left: 5px;
            }
        }

        .mapa-trilha {
            height: 292px !important;
            width: calc(100% - 16px);
        }

        .leaflet-container {
            border-radius: 8px 8px 8px 8px !important;
        }
    }

    .trilha-regularizacao__first-row {
        display: flex;
    }

    .trilha-regularizacao__titulo {
        color: var(--primary);
        font-size: 22px;
    }
}

@media (max-width: 768px) {
    #visao-trilha-pssc {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 16px;

        .trilha-regularizacao {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        .dados-solicitacao {
            display: grid;
            grid-template-columns: 50% 50%;
            gap: 0;
            justify-content: left;
        }

        .dados-gerais__grid {
            display: grid;
            grid-template-columns: 50% 50%;
            margin-top: 16px;
            row-gap: 16px;
        }

        .inconformidades-encontradas {
            display: flex;
            flex-direction: column;
            gap: 16px;
            height: fit-content !important;

            .mapa-trilha {
                height: 327px !important;
                width: 100%;
            }
        }

        .orientacoes-container {
            padding: 8px;
        }

    }
}
</style>
